import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "5-smart-ways-to-lower-your-foam-roof-recoating-cost-in-phoenix";
export const Route = createFileRoute("/5-smart-ways-to-lower-your-foam-roof-recoating-cost-in-phoenix")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
